<!-- 
<HNB active="关于我们" single-title="部位推荐"></HNB>
参数：active 传入对应值 激活样式
参数：singleTitle 单个标题
-->
<template>
	<div class="navigationBar">
		<div class="navigationBarBox" :style="widthAni">
			<div class="navigationBarLine">
				<div class="nb-logo " @click="hrefTo" data-link='index'>
					<!-- <SvgIcon svg-name='lfLogoTxt' size="80"></SvgIcon> -->
					<img :src="logourl" style="width: 80px;height: 80px;" alt="乐范logo"/>
				</div>
				<ul class="nb-ul" v-if="!singleTitle">
					<li v-for="item in nList" :key="item.title" :class="item.title==active?'active':''" @click="hrefTo" :data-link="item.link">{{item.title}}</li>
				</ul>
				<ul class="nb-ul-single" v-if="singleTitle">
					<li class="singleTile">{{singleTitle}}</li>
				</ul>
				<!-- <div class="nb-use" v-if="!singleTitle">
					<div class="iconfont">&#xe60a;</div>
					<div>EN/CH</div>
				</div> -->
				<div class="nb-use" v-if="singleTitle">
					<div class="backLine" @click="back">BACK</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SvgIcon from 'components/SvgIcon.vue'
	export default {
		name: 'navigationBar',
		props: {
			active: {
				type: String
			},
			singleTitle: {
				default: false
			},
			flag:{
				default:false
			}
		},
		components: {
			SvgIcon
		},
		data() {
			return {
				logourl:this.GLOBAL.imgHost + '/images/lefanlogo.png',
				widthAni: 'max-width:1024px;margin-top:20px;',
				nList: [{
						title: '关于我们',
						link: 'about-us'
					},
					{
						title: '产品介绍',
						link: 'product'
					},
					{
						title: '服务支持',
						link: 'service'
					},
					{
						title: '经营渠道',
						link: 'shop'
					}
				]
			};
		},
		mounted() {
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		methods: {
			//监听滚动
			getScroll() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let pageWidth = document.documentElement.clientWidth;
				if(that.flag==false){	
					if (scrollTop > 0) {
						//公式计算 滚动200高度 让导航栏宽度至100%
						that.widthAni = 'max-width:' + (parseInt((scrollTop / 200 > 1 ? 1 : scrollTop / 200) * (pageWidth - 1024)) + 1024) +
							'px;';
						that.widthAni += 'margin-top:' + (20 - scrollTop > 0 ? 20 - scrollTop : 0) + 'px;';
					}else{
						that.widthAni='max-width:1024px;margin-top:20px;';
					}
				}else{
					that.widthAni = 'max-width:' + '100%'
				}
				
			},
			//跳转页面
			hrefTo(e) {
				// console.log(e.target.dataset.link);
				this.$router.push({
					path: '/' + e.target.dataset.link
				})
			},
			back() {
				this.$router.go(-1); //返回上一层
			}
		}
	}
</script>

<style scoped>
	.navigationBar {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: center;
		position: fixed;
		z-index: 99;
	}

	.navigationBar .navigationBarBox {
		width: 100%;
		max-width: 1024px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 25px 50px 0px rgba(41, 44, 51, 0.1);
		border-radius: 4px;
		/* padding-left: 3.125rem; */
	}

	.navigationBar .navigationBarLine {
		width: 100%;
		max-width: 1024px;
		display: flex;
		flex-direction: row;
	}

	.navigationBar .nb-logo {
		width: 10%;
		color: #42B983;
		text-align: left;
		cursor: pointer;
		margin-left: 3.125rem;
	}

	.navigationBar .nb-ul {
		width: 60%;
		list-style-type: none;
		padding: 2px 0px;
		margin: 0px;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		padding-left: 40px;
	}

	.navigationBar .nb-ul li {
		font-size: 1rem;
		 
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		height: 100%;
		display: flex;
		align-items: center;
		cursor: pointer;
		line-height: 100%;
		border-bottom: 0.1875rem white solid;
	}

	.nb-ul li.active {
		border-bottom: 0.1875rem #00C785 solid;
		color: #00C785;
		font-weight: bold;
	}

	.navigationBar .nb-use {
		width: 30%;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
	}

	.nb-ul-single {
		width: 60%;
		list-style-type: none;
		padding: 0px;
		margin: 0px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding-left: 60px;
	}

	.navigationBar .nb-ul-single li.singleTile {
		color: #00C785;
		font-weight: 400;
		font-size: 1rem;
		font-weight: bold
	}

	.backLine {
		text-decoration: underline;
		cursor: pointer;
	}
</style>
